// extracted by mini-css-extract-plugin
export default {"create":"CommentSection_create__TBGui"};